

import React, { useState } from 'react';
import { Col, Input, Row, Checkbox, Button, Form, Select } from 'antd';
import { CaretDownOutlined, CloseCircleOutlined } from '@ant-design/icons';
import './BulkCommunication.css';
import { vacncsproperties } from '../../../../../data/vacancies';

const MessageBox = ({ id, onDelete }) => {

    const [deleteConfirmed, setDeleteConfirmed] = useState(false);


    const handleDelete = () => {
        if (deleteConfirmed) {
            onDelete(id);
        } else {
            setDeleteConfirmed(true);
        }
    };
    return (

        <Row gutter={[10, 0]} style={{}}>
            <Col span={22}>
                <Col style={{ margin: '20px 0px', color: 'gray' }}>
                    <Form.Item
                        label="Show In"
                        name="Checkbox"
                    >
                        <Checkbox>Tenant/Homeowner Portal</Checkbox>
                        <Checkbox>Owner Portal</Checkbox>
                    </Form.Item>
                </Col>

                <Col style={{ margin: '40px 0px 10px 0px', color: 'gray' }}>


                    <Form.Item label="Choose which property, group, or portfolio this message will be applie
    d to. Leave blank for all.">
                        <Select
                            showSearch
                            allowClear
                            placeholder="Search by Property"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.label ?? "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            style={{
                                width: "100%",
                            }}
                            options={vacncsproperties}
                        />
                    </Form.Item>

                </Col>

                <Col style={{ margin: '20px 0px', color: 'gray' }} >
                    <Form.Item
                        label="Message"
                        name="message"
                        rules={[{
                            required: true,
                            message: 'Please input your Message!'
                        }]}

                    >
                        <Input.TextArea required rows={2} cols={1000}
                            placeholder="Type a message" />
                    </Form.Item>
                </Col>
            </Col>

            <Col span={2} >
                <Form.Item
                >
                    <Button type="text" className='btnnntest'
                        onClick={handleDelete}
                    >
                        {deleteConfirmed ? "Delete" :
                            < CloseCircleOutlined />
                        }
                    </Button>
                </Form.Item>
            </Col>
        </Row>



    );
};

export default MessageBox;
